import { Page, BasePlanVO } from "@/libs/model/common/index";
/**俱乐部ID */
export class ClubId {
  constructor() {
    this.clubId = "";
  }
}

/**俱乐部ID数组 */
export class BatchClubId {
  constructor() {
    this.clubId = [];
  }
}

/**新增和更新俱乐部 */
export class ClubVO extends BasePlanVO {
  constructor() {
    super();
    this.clubId = "";
    this.disciplineList = "";
  }
}

/**查询俱乐部分页列表 */
export class ClubPageListVO extends Page {
  constructor() {
    super();
    this.approveStatus = "";
    this.discipline = "";
    this.name = "";
    this.province = "";
    this.year = "";
  }
}
